export const RESET_PASSWORD_REQUEST_REQUEST = "RESET_PASSWORD_REQUEST_REQUEST";
export const RESET_PASSWORD_REQUEST_SUCCESS = "RESET_PASSWORD_REQUEST_SUCCESS";
export const RESET_PASSWORD_REQUEST_FAILURE = "RESET_PASSWORD_REQUEST_FAILURE";
export const RESET_RESET_PASSWORD_REQUEST_STATE = "RESET_RESET_PASSWORD_REQUEST_STATE";
